import { useState } from "react"
import { router } from "@inertiajs/react"
import { Form, Input } from "@/components/Form"
import Button from "@/components/Button"

const ConfirmRegistrationForm = ({
  email,
  errors,
}: {
  email: string
  errors: Record<string, string[]>
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async ({ code }) => {
    setIsSubmitting(true)
    router.post(
      "/register/confirm",
      { email, code },
      {
        onFinish: () => setIsSubmitting(false),
      }
    )
  }
  return (
    <Form
      defaultValues={{ email }}
      errors={errors}
      onSubmit={handleSubmit}
      className="my-2 flex flex-col lg:flex-row"
    >
      <div className="flex-1">
        <Input
          name="code"
          placeholder="Enter activation code"
          type="text"
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck="false"
          className="h-12 px-3 text-center lg:text-left"
          required
          disabled={isSubmitting}
        />
        <Input name="email" type="hidden" />
      </div>
      <div className="mt-2 shrink-0 lg:mt-0 lg:ml-2">
        <Button className="h-12" disabled={isSubmitting}>
          {isSubmitting ? "Hold on" : "Activate account"}
        </Button>
      </div>
    </Form>
  )
}

export default ConfirmRegistrationForm
